import React, { useEffect } from "react";
import images from "../../constants/images";
import "./LifeOfGalaxyChain.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-image-lightbox/style.css";
import Slider from "react-slick";
import Lightbox from "react-image-lightbox";
import { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";

const LifeOfGalaxyChain = ({ careerDetails }) => {
  const LifeImageSlider = () => {
    const images = [
      require("../../assets/duplexRollerChain.png"),
      require("../../assets/duplexRollerChain.png"),
      require("../../assets/duplexRollerChain.png"),
      require("../../assets/duplexRollerChain.png"),
    ];

    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true,          // enable auto slide
      autoplaySpeed: 3000,     // 3000ms = 3 seconds
    };

    return (
      <>
        <Slider {...settings}>
          {careerDetails?.career_images?.map((img, index) => (
            <div
              key={index}
              onClick={() => {
                setPhotoIndex(index);
                setIsOpen(true);
              }}
              style={{ border: "none" }}
            >
              <img src={img?.image_full_path} alt={`slide-${index}`} className="slider_imge" />
            </div>
          ))}
        </Slider>

        {isOpen && (
         <Lightbox
  mainSrc={careerDetails?.career_images[photoIndex]?.image_full_path}
  nextSrc={
    careerDetails?.career_images[
      (photoIndex + 1) % careerDetails?.career_images.length
    ]?.image_full_path
  }
  prevSrc={
    careerDetails?.career_images[
      (photoIndex + careerDetails?.career_images.length - 1) %
        careerDetails?.career_images.length
    ]?.image_full_path
  }
  onCloseRequest={() => setIsOpen(false)}
  onMovePrevRequest={() =>
    setPhotoIndex(
      (photoIndex + careerDetails?.career_images.length - 1) %
        careerDetails?.career_images.length
    )
  }
  onMoveNextRequest={() =>
    setPhotoIndex((photoIndex + 1) % careerDetails?.career_images.length)
  }
/>

        )}
      </>
    );
  };

  return (
    <section className="life-at-galaxy">
      <h2>Life at Galaxy Chains</h2>
      <div className="underline"></div>
      <div className="life_bg_main_div">
        <div className="container align-items-center">
          <div className="row align-items-center justify-content-md-between justify-content-center life_of_container mt-0">
            <div className="col-12 col-lg-5">
              <p className="life_of_desc">
                {careerDetails?.description1}
              </p>
              <div className="d-flex align-items-center justify-content-center align-self-center mb-5">
                <div
                  className="text-center fw-bold text-light"
                  style={{ fontSize: "16px" }}
                >
                  {careerDetails?.description2}
                </div>
              </div>
              <div className="text-light">
                {careerDetails?.description3}
              </div>

              <div className="row align-items-center justify-content-center mt-4 border-0">
                {/* <div className="d-flex col justify-content-center align-items-center"> */}

                {careerDetails?.looking_for?.map((item, index) => {
                  return (
                    <>
                      <ul className="job-skillsok m-2 col">
                        <li className="d-flex align-items-center gap-1">
                          <FaCheckCircle
                            style={{ fontSize: "12px", color: "white" }}
                          />
                          {item}
                        </li>
                      </ul>
                    </>
                  )
                })}
                {/* <ul className="job-skillsok m-2 col">
                  <li className="d-flex align-items-center gap-1">
                    <FaCheckCircle
                      style={{ fontSize: "12px", color: "white" }}
                    />
                    Committed
                  </li>
                </ul>
                <ul className="job-skillsok m-2 col">
                  <li className="d-flex align-items-center gap-1">
                    <FaCheckCircle
                      style={{ fontSize: "12px", color: "white" }}
                    />
                    Collaborative
                  </li>
                </ul>
                <ul className="job-skillsok m-2 col">
                  <li className="d-flex align-items-center gap-1">
                    <FaCheckCircle
                      style={{ fontSize: "12px", color: "white" }}
                    />
                    Adaptable
                  </li>
                </ul> */}
                {/* </div> */}
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <LifeImageSlider />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LifeOfGalaxyChain;
